import React, { Component } from 'react';

export default class DefaultGuy extends Component {

    render(){
        const fillStyle = {fill:this.props.fillColor}
        return (
            <svg width="100%" height="100%" viewBox="0 0 80 80" style={this.props.svgStyle}>
              <g style={fillStyle}>
                <path d="M59.974,80.03l-39.559,0c0.962,-4.354 2.648,-8.27 4.86,-11.476c-11.177,-5.514 -18.874,-17.028 -18.874,-30.326c0,-18.65 15.143,-33.791 33.794,-33.791c18.65,0 33.793,15.141 33.793,33.791c0,13.298 -7.697,24.812 -18.874,30.326c2.212,3.205 3.898,7.121 4.86,11.476Zm-11.741,-29.36c-1.876,2.597 -4.919,4.216 -8.233,4.216c-3.308,0 -6.357,-1.619 -8.235,-4.218c-0.51,-0.703 -1.494,-0.862 -2.198,-0.354c-0.707,0.51 -0.864,1.494 -0.355,2.201c2.459,3.402 6.445,5.521 10.788,5.521c4.348,0 8.331,-2.119 10.788,-5.523c0.509,-0.707 0.35,-1.689 -0.355,-2.199c-0.706,-0.508 -1.691,-0.351 -2.2,0.356Zm-20.907,-10.23c0,-1.657 -1.343,-3 -2.999,-3c-1.657,0 -3.001,1.343 -3.001,3c0,1.656 1.344,2.999 3.001,2.999c1.656,0 2.999,-1.343 2.999,-2.999Zm28.347,-3c-1.656,0 -2.999,1.343 -2.999,3c0,1.656 1.343,2.999 2.999,2.999c1.658,0 3.001,-1.343 3.001,-2.999c0,-1.657 -1.343,-3 -3.001,-3Z"/>
              </g>
            </svg>
        )
    }
}
